import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToastService } from '@wephone-utils';
import { TranslateService } from '@ngx-translate/core';
import { FileEntryEntity } from '@wephone-core/model/entity/fileentry';
import { UserRepository } from '@wephone-core/model/repository/user';
import { IUserEntity } from '@wephone-core/model/entity/user.i';
import { _tk, _ti } from '@wephone-translation';
import { LoggerService } from '@wephone-utils/services/logger.service';

@Component({
  selector: 'user-voice-mail',
  templateUrl: './user-voice-mail.html',
  styleUrls: ['./user-voice-mail.scss']
})
export class UserVoiceMailComponent {
  @Input()
  public user: IUserEntity;
  @Output()
  public onChange: EventEmitter<any> = new EventEmitter();

  lang: string;

  voicemail_welcome_file: FileEntryEntity;
  constructor(
    private toastService: ToastService,
    private translateService: TranslateService,
    private logger: LoggerService
  ) {}

  ngOnInit() {
    this.voicemail_welcome_file = this.user.voicemail_welcome_file; // to avoid call this func too much time
    this.lang = this.translateService.currentLang || 'default';
  }

  get receive_voicemail_attachement(): boolean {
    return this.user && !!this.user.voicemail_in_attachement;
  }

  set receive_voicemail_attachement(voicemail_in_attachement: boolean) {
    if (this.user) {
      this.user.voicemail_enabled = 1;
      this.user.voicemail_by_mail_enabled = 1;
      this.user.voicemail_in_attachement = voicemail_in_attachement ? 1 : 0;

      let field_list = ['voicemail_enabled', 'voicemail_by_mail_enabled', 'voicemail_in_attachement'];
      this.updateAttrs(field_list);
    }
  }

  public updateAttrs(field_list: Array<string>, extra_data: { [id: string]: any } = null) {
    if (!this.user.id) {
      this.logger.error('No user updated');
      return;
    }
    if (!_.isArray(field_list)) {
      throw new Error('Parameter invalid !');
    }

    UserRepository.getInstance<any>()
      .saveAttrs(this.user, field_list, extra_data)
      .then(
        data => {
          this.toastService.show(_ti('public.message.update_success'));
          if (this.onChange) {
            this.onChange.emit(this.user);
          }
        },
        response => {
          let error_data = response && response.error ? response.error : null;
          this.logger.error('Edit Item error', error_data.error);
          let msg =
            error_data && error_data.error && error_data.error.message
              ? error_data.error.message
              : 'public.message.update_failure';
          this.toastService.showError(msg);
        }
      );
  }

  public updateMailboxWelcomeFile = $event => {
    let new_file_entry: FileEntryEntity = $event.new_file_entry;
    if (!new_file_entry && !$event.remove) {
      this.logger.error('File entry no longer exist');
      return;
    }

    this.voicemail_welcome_file = new_file_entry; //to update in UI

    this.user.voicemail_welcome_file = new_file_entry;
    this.updateAttrs(['voicemail_welcome_file_id'], {
      voicemail_welcome_file_id: new_file_entry ? new_file_entry.id : null
    });
  };
}
